import { render, staticRenderFns } from "./inscrie.vue?vue&type=template&id=80bef43c&"
import script from "./inscrie.vue?vue&type=script&lang=js&"
export * from "./inscrie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports